module.exports = __webpack_public_path__ + "static/egyptian-bedding-set-white-2-2af49eeb220033f006fc891278c64816.webp";